const panelShare = () => {
  const selectors = {
    copy: '.panel-share-link__copy',
    instagram: '.panel-share-link__instagram',
  }

  async function doCopy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(textarea);
    }
  }

  function showCopiedState(el, label) {
    const prevLabel = el.getAttribute('aria-label') || '';
    el.setAttribute('aria-label', label || 'copied');
    el.classList.add('is-copied');
    setTimeout(() => {
      el.setAttribute('aria-label', prevLabel);
      el.classList.remove('is-copied');
    }, 2000);
  }

  function copyHandlerEl(el) {
    const url = el.dataset.shareUrl || window.location.href;

    doCopy(url)
      .then(() => showCopiedState(el))
      .catch(() => {});
  }

  function instagramHandlerEl(el) {
    const url = el.dataset.shareUrl || window.location.href;
    const title = el.dataset.shareTitle || document.title || '';

    if (navigator.share) {
      navigator.share({ title: title, text: title, url: url }).catch(() => {
        // fallback to copy on error or cancel
        doCopy(url).then(() => showCopiedState(el, 'copied for Instagram')).catch(() => {});
      });
      return;
    }

    // No Web Share API: fallback to copying the URL
    doCopy(url).then(() => showCopiedState(el, 'copied for Instagram')).catch(() => {});
  }

  function delegatedClickHandler(e) {
    const copyEl = e.target.closest && e.target.closest(selectors.copy);
    if (copyEl) {
      e.preventDefault();
      copyHandlerEl(copyEl);
      return;
    }

    const instaEl = e.target.closest && e.target.closest(selectors.instagram);
    if (instaEl) {
      e.preventDefault();
      instagramHandlerEl(instaEl);
      return;
    }
  }

  function init() {
    // Use event delegation to ensure handlers work for dynamic content
    document.removeEventListener('click', delegatedClickHandler);
    document.addEventListener('click', delegatedClickHandler);
  }

  return { init };
};

export { panelShare };
